module.exports = __webpack_public_path__ + "static/media/ND-Trigger-Artwork-1450x1450.4ee6e3c1.jpg";